import React from 'react'
import { Button, Card, CardContent, Input, Label } from '@/shared/ui'
import { getSlackAppConfig, setSlackAppConfig } from '../services/slackService'

export default function SlackCredentialsForm() {
  const [loading, setLoading] = React.useState(true)
  const [clientId, setClientId] = React.useState('')
  const [clientSecret, setClientSecret] = React.useState('')
  const [signingSecret, setSigningSecret] = React.useState('')
  const [hasSecret, setHasSecret] = React.useState(false)
  const [saved, setSaved] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    (async () => {
      try {
        const cfg = await getSlackAppConfig()
        setClientId(cfg.client_id || '')
        setHasSecret(!!cfg.has_secret)
      } catch (e:any) {
        setError(e.message || String(e))
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  async function onSave(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSaved(false)
    try {
      await setSlackAppConfig(clientId.trim(), clientSecret.trim(), signingSecret.trim())
      setHasSecret(true)
      setSaved(true)
      setClientSecret('')
      setSigningSecret('')
    } catch (e:any) {
      setError(e.message || String(e))
    }
  }

  return (
    <Card>
      <CardContent className="pt-4">
        <form onSubmit={onSave} className="space-y-3">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
            <div>
              <Label>Client ID</Label>
              <Input value={clientId} onChange={e=> setClientId(e.target.value)} placeholder="1234567890.1234567890"/>
            </div>
            <div>
              <Label>Client Secret {hasSecret && <span className="text-xs text-foreground/60">(salvo)</span>}</Label>
              <Input type="password" value={clientSecret} onChange={e=> setClientSecret(e.target.value)} placeholder="••••••••"/>
            </div>
            <div>
              <Label>Signing Secret {hasSecret && <span className="text-xs text-foreground/60">(salvo)</span>}</Label>
              <Input type="password" value={signingSecret} onChange={e=> setSigningSecret(e.target.value)} placeholder="••••••••"/>
            </div>
          </div>
          {error && <div className="text-sm text-red-500">{error}</div>}
          <div>
            <Button type="submit" disabled={loading}>Salvar credenciais</Button>
            {saved && <span className="ml-3 text-sm text-green-600">Salvo.</span>}
          </div>
        </form>
      </CardContent>
    </Card>
  )
}

